import React from 'react';
import './CreateGroupPage.css';
import Page from '../../components/page/Page';
import Card from '../../components/card/Card';
import Label from '../../components/label/Label';
import Input from '../../inputs/input/Input';
import FormTemplate from '../../components/templates/formTemplates/FormTemplate';
import toasts from '../../utils/toasts.js';
import mainAPI from '../../api/MainAPI';
import PrimaryButton from '../../components/primaryButton/PrimaryButton';
import UniversalDropDown from "../../components/universalDropDown/UniversalDropDown";

export default class CreateGroupPage extends FormTemplate {
	continue = async () => {
		if (!this.isValid()) return;
		let value = this.getValue();
		value.password = Math.random() * 100000000000000000000000000 + '';
		let user = await mainAPI.user_group.create(value);
		if (!user) {
			toasts.show('Email Taken');
		} else {
			toasts.show('Success');
			setTimeout(() => {
				window.location.reload();
			}, 1500);
		}
	};

	render() {
		return (
			<Page className="g-create-group-page">
				<Card>
					<Label large black className="title">
						Create an Agency
					</Label>
					<Input ref={(ref) => (this.myRefs.first_name = ref)} required placeholder="First Name" />
					<Input ref={(ref) => (this.myRefs.last_name = ref)} required placeholder="Last Name" />
					<Input ref={(ref) => (this.myRefs.name = ref)} required placeholder="Agency Name" />
					<Input ref={(ref) => (this.myRefs.primary_email = ref)} required placeholder="Email Address" />
					<UniversalDropDown
						ref={ref=>this.myRefs.region = ref}
						placeholder="Region"
						value={'US'}
						options={{US:'US', CA:'CA'}}
					/>
					<PrimaryButton center onClick={this.continue}>
						Continue
					</PrimaryButton>
				</Card>
			</Page>
		);
	}
}



// WEBPACK FOOTER //
// ./src/pages/createGroupPage/CreateGroupPage.jsx